export default __webpack_public_path__ + "static/media/people_type_couple_active.71782203.svg";